import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
// import { RouterLink } from '@angular/router';
import { DataTableColumn, DataTableComponent, DataTablePageChangedEvent } from '@shared/components/data-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { EmployeeResponse } from '../../employee.model';
import { ActionMenu } from "@shared/components/action-menu/action-menu";
import { useEmployeeActionMenu } from "./employee-action-menu-composable";

export type EmployeesPageChangedEvent = DataTablePageChangedEvent;

@Component({
  selector: 'employee-table',
  imports: [ DataTableComponent, ...SharedMaterialUIModule, ActionMenu],
  templateUrl: './employee-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeTableComponent {
  protected readonly columns: DataTableColumn<EmployeeResponse>[] = [
    {
      id: 'name',
      header: 'Name',
      value: (employee) => `${employee.firstName} ${employee.surname}`.trim(),
      cellClass: 'px-3 py-3 font-medium',
    },
    {
      id: 'employeeNumber',
      header: 'Employee #',
      value: (employee) => employee.employeeNumber,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'emailAddress',
      header: 'Email',
      value: (employee) => employee.emailAddress,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'companyName',
      header: 'Company',
      value: (employee) => employee.companyName,
      cellClass: 'px-3 py-3 text-xs',
    },
    {
      id: 'isActive',
      header: 'Status',
      value: (employee) => (employee.isActive ? 'Active' : 'Inactive'),
      cellClass: 'px-3 py-3',
    },
  ];

  readonly employees = input<EmployeeResponse[]>([]);
  readonly loading = input(false);
  readonly searchTerm = input('');
  readonly pageNumber = input(1);
  readonly pageSize = input(25);
  readonly totalCount = input(0);
  readonly totalPages = input(0);
  readonly canActivate = input(false);
  readonly canDeactivate = input(false);
  readonly canUpdate = input(false);
  readonly actionEmployeeId = input<string | null>(null);

  readonly refreshed = output<void>();
  readonly searchChanged = output<string>();
  readonly pageChanged = output<EmployeesPageChangedEvent>();
  readonly toggled = output<EmployeeResponse>();
  readonly manageDependants = output<EmployeeResponse>();
  readonly actionMenuItems = useEmployeeActionMenu().employeeActionMenuItems;
  readonly actions: Record<string, any> = {
    'pageChanged': this.pageChanged,
    'toggled': this.toggled,
    'manageDependants': this.manageDependants,
  };
}
